import { SheqManagerConfiguration } from "./components/SheqManagerConfiguration";

export default SheqManagerConfiguration;